// WP1 owns this file after WP0 (architecture §7.5, §10.14).
import { z } from 'zod';

export const BriefingBody = z.object({ mode: z.enum(['text', 'stimme']) });
export type BriefingBody = z.infer<typeof BriefingBody>;
export interface BriefingResponse { threadId: string; runId: string }
